import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  path: string;
};

const ThankYou: React.FC<Props> = ({ path }) => {
  return (
    <div className="px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="max-w-max mx-auto">
        <main className="sm:flex">
          <div className="sm:ml-6">
            <div>
              <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                Appointment scheduled!
              </h1>
              <p className="mt-1 text-base text-gray-500 max-w-xl">
                We look forward to seeing you at your next appointment. For your convenience, you
                can view and manage all your appointments by clicking the link below.
              </p>
            </div>
            <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent">
              <Link
                to={`/${path}/appointments`}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-500 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              >
                View appointments
              </Link>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ThankYou;
